import * as _worker_threads2 from "worker_threads";

var _worker_threads = "default" in _worker_threads2 ? _worker_threads2.default : _worker_threads2;

var exports = {};

/*! node-domexception. MIT License. Jimmy Wärting <https://jimmy.warting.se/opensource> */
if (!globalThis.DOMException) {
  try {
    const {
      MessageChannel
    } = _worker_threads,
          port = new MessageChannel().port1,
          ab = new ArrayBuffer();
    port.postMessage(ab, [ab, ab]);
  } catch (err) {
    err.constructor.name === "DOMException" && (globalThis.DOMException = err.constructor);
  }
}

exports = globalThis.DOMException;
export default exports;